module.exports = __webpack_public_path__ + "7dddc41afab6c0760d273b3a4ce90dee.MP3";